import { Link } from 'gatsby'
import React, { useEffect, useMemo } from 'react'

import Categories from './Categories/Categories'
import { useStoreContext } from '../../../../../../contexts/StoreContext'
import './all-categories-container.scss'

interface AllCategoriesContainerProps {
  allCategoriesVisibility: boolean
  position?: number
  closeMenu: () => void
  setSecondVisibleColumn: (secondVisibleColumn: boolean) => void
  subCategoriePosition: number
  setSubCategoriePosition: (postion: number) => void
  currentCategorie: string
  setCurrentCategorie: (currentCategorie: string) => void
}

export const AllCategoriesContainer = ({
  allCategoriesVisibility,
  position,
  closeMenu,
  currentCategorie,
  setCurrentCategorie,
  setSubCategoriePosition,
  subCategoriePosition,
  setSecondVisibleColumn,
}: AllCategoriesContainerProps) => {
  const { allCategories } = useStoreContext()

  const categorieLink = useMemo(() => {
    return `/${allCategories?.[position ?? 0]?.slug}`
  }, [allCategories, position])

  useEffect(() => {
    if (currentCategorie === '') {
      return
    }

    setSecondVisibleColumn(true)
  }, [currentCategorie])

  if (!allCategoriesVisibility) {
    return null
  }

  const hasRestriction =
    allCategories?.[position ?? 0].slug === 'restricao-alimentar'

  return (
    <div className="all-categories">
      <div className="all-categories-title">
        <h1>{allCategories?.[position ?? 0].title}</h1>
        {!hasRestriction && (
          <Link onClick={closeMenu} to={categorieLink}>
            Ver Tudo
          </Link>
        )}
      </div>
      <div
        className={`${
          hasRestriction ? 'restriction-content' : 'all-categories-content'
        }`}
      >
        <Categories
          subCategoriePosition={subCategoriePosition}
          setSubCategoriePosition={setSubCategoriePosition}
          setCurrentCategorie={setCurrentCategorie}
          currentCategorie={currentCategorie}
          closeMenu={closeMenu}
          categories={allCategories?.[position ?? 0].categorie}
          departamentSlug={allCategories?.[position ?? 0]?.slug}
        />
      </div>
    </div>
  )
}
